const storeDependents = {
    namespaced: true,
    state: {
        parentId: null,
        dependents: [],
        ready: null,
    },
    getters: {
        dependent: state => id => {
            return state.dependents.find(x => x.participantId == id);
        },
    },
    actions: {
        async load(context, data) {
            if (!data || !data.participantId) return;
            if(context.state.parentId == data.participantId && !data.force) return;
            context.commit("setReady", false);
            context.commit("setParent", data.participantId);
            let dependents = await romeApi.get(`/participant/${data.participantId}/dependents`);
            dependents.sort((a, b) => a.firstName.localeCompare(b.firstName));
            context.commit("setDependents", dependents);
            context.commit("setReady", true);
        }, 
    },
    mutations: {
        setParent(state, parentId) {
            state.parentId = parentId;
        },
        setDependents(state, deps) {
            state.dependents = deps;
        },
        setReady(state, isReady) {
            state.ready = isReady;
        },
    }
};

export default storeDependents;
  


// WEBPACK FOOTER //
// ./src/participant/x-dependents.js